import axios from "axios";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { __API_URL__ } from "../SERVER_URL";
import { showApiErrorToast } from "../utils/helpers";
import { toast } from "react-toastify";

const updateAdvancedSurvey = async ({ surveyId, payload }) => {
  const token = localStorage.getItem("token");

  const URL = `${__API_URL__}/api/survey/advanced-surveys/${surveyId}/update/`;

  const res = await axios.patch(URL, payload, {
    headers: {
      Authorization: `Token ${token}`,
    },
  });

  return res.data;
};

const useUpdateAdvancedSurveyMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: updateAdvancedSurvey,
    onSuccess: (_, variables) => {
      queryClient.removeQueries({
        queryKey: ["advanced_survey", variables.surveyId],
      });
      queryClient.removeQueries({ queryKey: ["advanced_surveys"] });
      toast.success("Survey updated successfully");
    },
    onError: (error) => {
      showApiErrorToast(error, "Failed to update survey");
    },
  });
};

export default useUpdateAdvancedSurveyMutation;
